/**
 * @author 潘维吉
 * @description http核心工具类
 * 用于扩展各种需求 根据动态参数 插拔式扩展
 */
/**
 *  驼峰转换下划线
 */
function humpToLine(name) {
    if (name) {
        return name.replace(/([A-Z])/g, '_$1').toLowerCase();
    }
    return '';
}
function setOrder(order) {
    if (order === 'descend') {
        return 'desc';
    }
    if (order === 'ascend') {
        return 'asc';
    }
    return order;
}
export function requestPage(config) {
    let { url, data } = config;
    if (!url.endsWith('/page')) {
        return;
    }
    // 处理请求参数
    const { current, pageSize, sorter } = data;
    config.data.page = current; // 当前页
    config.data.size = pageSize; // 当前页数
    // 排序参数
    if (sorter) {
        const splitIndex = sorter.lastIndexOf('_');
        config.data.sort = humpToLine(sorter.substr(0, splitIndex));
        config.data.order = setOrder(sorter.substr(splitIndex + 1));
    }
}
export function responsePage(data, url) {
    if (!url.endsWith('/page')) {
        return data;
    }
    const { page, size, total, hasNextPage, list } = data.data;
    // 分页参数
    const result = {
        current: page,
        pageSize: size,
        code: data.code,
        success: data.code === 200,
        data: list,
        total,
        hasNextPage,
        msg: data.msg,
    };
    return {
        ...data,
        ...result,
    };
}
import notification from 'ant-design-vue/es/notification';
export function webErrorMsg(data) {
    if (data && data.code) {
        if (data.code === 400) {
            notification.error({ message: '系统错误', description: data.msg, duration: null });
        }
        if (data.code === 401) {
            notification.error({ key: 401, message: '系统提醒', description: data.msg, duration: 5 });
        }
        if (data.code == 500) {
            notification.error({
                message: '服务端错误',
                description: data.msg ? data.msg.substr(0, 150) : null,
            });
        }
    }
    else {
        if (data.status && data.status === 401) {
            // 重新登录
            toLogin();
        }
        else if (data.status && data.status === 403) {
            notification.error({ message: '权限不足', description: '当前用户无此操作权限，请联系管理员' });
        }
        else {
            notification.error({
                message: '系统错误',
                description: '未知错误，请联系管理员',
                duration: null,
            });
        }
    }
}
function toLogin() {
    notification.error({ message: '去登录', description: '用户信息失效，请重新登录' });
    localStorage.removeItem('token');
    window.location.reload();
}
//# sourceMappingURL=http-util.js.map